import { UserTrainingDTO } from './UserTrainingDTO'

export class UserTraining {
  private _id: string
  private _trainingID: string
  private _userID: string
  private _startDate: Date
  private _finishDate: Date
  private _frecuency: number // 1: mañana, 2: tarde, 3: noche
  private _series: number
  private _repetitions: number
  private _completed: boolean
  private _title: string
  private _description: string
  private _image: string

  constructor(p: UserTrainingDTO) {
    this._id = p.id
    this._trainingID = p.trainingID
    this._userID = p.userID
    this._startDate = p.startDate
    this._finishDate = p.finishDate
    this._frecuency = p.frecuency
    this._series = p.series
    this._repetitions = p.repetitions
    this._completed = p.completed
    this._title = p.title ?? ''
    this._description = p.description ?? ''
    this._image = p.image ?? ''
  }

  get id(): string {
    return this._id
  }

  set id(value: string) {
    this._id = value
  }

  get trainingID(): string {
    return this._trainingID
  }

  set trainingID(value: string) {
    this._trainingID = value
  }

  get userID(): string {
    return this._userID
  }

  set userID(value: string) {
    this._userID = value
  }

  get startDate(): Date {
    return this._startDate
  }

  set startDate(value: Date) {
    this._startDate = value
  }

  get finishDate(): Date {
    return this._finishDate
  }

  set finishDate(value: Date) {
    this._finishDate = value
  }

  get frecuency(): number {
    return this._frecuency
  }

  set frecuency(value: number) {
    this._frecuency = value
  }

  get series(): number {
    return this._series
  }

  set series(value: number) {
    this._series = value
  }

  get repetitions(): number {
    return this._repetitions
  }

  set repetitions(value: number) {
    this._repetitions = value
  }

  get completed(): boolean {
    return this._completed
  }

  set completed(value: boolean) {
    this._completed = value
  }

  get title(): string {
    return this._title
  }

  set title(value: string) {
    this._title = value
  }

  get description(): string {
    return this._description
  }

  set description(value: string) {
    this._description = value
  }

  get image(): string {
    return this._image
  }

  set image(value: string) {
    this._image = value
  }
}
